module.exports = __webpack_public_path__ + "static/media/A.9ef6460e.svg";